import React from 'react'
import { MonthCaptionProps } from 'react-day-picker'
import { useTranslation } from 'react-i18next'
import { getReadableMonthName } from '../constants'

interface MonthCaptionExtendedProps extends MonthCaptionProps {
  yearColor?: string
}

export function MonthCaption({
  calendarMonth,
  yearColor,
  ...props
}: MonthCaptionExtendedProps) {
  const { t } = useTranslation()

  return (
    <div {...props}>
      <p style={{ fontWeight: 600 }}>
        {t(getReadableMonthName(calendarMonth.date))}{' '}
        <span style={{ color: yearColor }}>
          {calendarMonth.date.getFullYear()}
        </span>
      </p>
    </div>
  )
}
